<p-progressSpinner [hidden]="!loading"></p-progressSpinner>
<div class="p-fluid p-formgrid grid">
  <div [class]="'field p-field col-12 md:col-12'" *ngIf="profileTypeItems.length>0">
    <p-tabMenu #menuTypes [model]="profileTypeItems" [activeItem]="profileTypeActive"
    (click)="filterProfileType(menuTypes.activeItem)" [scrollable]="true"></p-tabMenu>
  </div>
  <div [class]="'field p-field col-12 md:col-12'">
    <p-listbox [options]="displayedRecords" [(ngModel)]="selectedRecords"
               (onChange)="selectedRecordsChange.emit(selectedRecords)" [metaKeySelection]="false"
               [checkbox]="true" [filter]="true" [multiple]="true" optionLabel="title" optionValue="name"
               [listStyle]="{'max-height':'300px','height':'300px'}" [disabled]="loading">
      <ng-template let-record pTemplate="item">
        <div class="recap-item" [pTooltip]="StringUtils.humanize(record.name)">
          <i [class]="'fa fa-file-'+(ExportFormat.XLS===record.exportFormat?'excel':'csv')"></i>
          <span class="recap-title">{{StringUtils.humanize(record.name)}}</span>
          <i [class]="'cc-recap-fav '+(record.isFavorite?'fa-solid':'fa-regular')+' fa-star'"
             (click)="addRemoveToFav(record, $event)"></i>
        </div>
      </ng-template>
    </p-listbox>

  </div>
  <div [class]="'field p-field col-12 md:col-5'">
  </div>
  <div [class]="'field p-field col-12 md:col-7'">
    <p-toggleButton onIcon="fas fa-check" offIcon="fas fa-times"
                    [(ngModel)]="differential"
                    (onChange)="differentialChange.emit(differential)"
                    [disabled]="loading"
                    [onLabel]="'page.' + this.transPartKey + '.form.differential' | translate"
                    [offLabel]="'page.' + this.transPartKey + '.form.nodifferential' | translate"
    >
    </p-toggleButton>
  </div>
</div>
